module.exports = __webpack_public_path__ + "img/e64414a.jpg";